import { ColumnSizing } from '../tables-context';
import { MRT_ColumnDef } from 'material-react-table';
import { TableCell } from '../../../components/table/TableCell';
import React from 'react';
import { IAuditLogs } from '../../merchnts/merchant-interfaces';
import { DateComponent } from '../../../components/DateComponent';

export enum AuditLogsTableAccessorKeys {
	date = 'createdOn',
	tableName = 'tableName',
	name = 'userFirstName',
	operation = 'operation',
	affectedColumns = 'affectedColumns',
}

export const defaultAuditLogsColumnSizing: ColumnSizing = {
	[AuditLogsTableAccessorKeys.date]: 50,
	[AuditLogsTableAccessorKeys.tableName]: 50,
	[AuditLogsTableAccessorKeys.name]: 100,
	[AuditLogsTableAccessorKeys.operation]: 50,
	[AuditLogsTableAccessorKeys.affectedColumns]: 100,
};

export const defaultAuditLogsColumns: MRT_ColumnDef<IAuditLogs>[] = [
	{
		accessorKey: AuditLogsTableAccessorKeys.date,
		header: 'Timestamp date',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Timestamp date</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				<DateComponent value={renderedCellValue} isTime/>
			</TableCell>
		)
	},
	{
		accessorKey: AuditLogsTableAccessorKeys.tableName,
		header: 'Entity name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Entity name</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	{
		accessorKey: AuditLogsTableAccessorKeys.name,
		header: 'User name',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">User name</span>,
		Cell: ({ renderedCellValue, table, row }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{
					renderedCellValue || row?.original?.userLastName
						? (
							<div className="fc-text-overflow">
								<div>
									<span className="me-1">{renderedCellValue}</span>
									<span>{row?.original?.userLastName}</span>
								</div>
								<div className="text-muted fc-text-overflow">
									{row?.original?.userIp}
								</div>
							</div>
						) : '-'
				}
			</TableCell>
		)
	},
	{
		accessorKey: AuditLogsTableAccessorKeys.operation,
		header: 'Operation',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Operation</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => (
			<TableCell
				additionalClass="d-flex align-items-center main-font-family text-black"
				density={table?.options?.state?.density}
				isTextOverflow={true}
			>
				{renderedCellValue}
			</TableCell>
		)
	},
	{
		accessorKey: AuditLogsTableAccessorKeys.affectedColumns,
		header: 'Affected columns',
		enableSorting: false,
		Header: <span className="text-muted fw-bolder main-font-family">Affected columns</span>,
		Cell: ({ renderedCellValue, table }: any): JSX.Element => {
			const test = renderedCellValue ? JSON.parse(renderedCellValue).join(', ') : '-';
			return (
				<TableCell
					additionalClass="d-flex align-items-center main-font-family text-black"
					density={table?.options?.state?.density}
					isTextOverflow={true}
				>
					<span className="fc-text-overflow">{test}</span>
				</TableCell>
			);
		}
	},
];